import { useContext, useMemo } from 'react';
import { AllPermissions, getFeaturePermissions, getRowPermissions } from '../../auth/api';
import type { EntitySecurity } from '../../auth/Security';
import { SECURITY_ACTIONS } from '../../auth/Security';
import { UserContext } from '../../auth/UserContext';
import type { DataRowSecurityActionPermissions } from '../types';

export function useDataLegacyRowPermissions(
    feature: string,
    entitySecurity?: EntitySecurity
): DataRowSecurityActionPermissions {
    const { userProfile, activeOrganizationAccount, application } = useContext(UserContext);

    return useMemo(() => {
        const featurePermissions = getFeaturePermissions(userProfile, application, activeOrganizationAccount, feature);
        const rowPermissions = getRowPermissions(entitySecurity);
        const hasManage = featurePermissions[AllPermissions.Manage];

        return {
            [SECURITY_ACTIONS.READ]: rowPermissions[AllPermissions.Read],
            [SECURITY_ACTIONS.EDIT]: rowPermissions[AllPermissions.Edit] && hasManage,
            [SECURITY_ACTIONS.DELETE]: rowPermissions[AllPermissions.Delete] && hasManage,
            [SECURITY_ACTIONS.COMMENT]: rowPermissions[AllPermissions.Comment] && hasManage,
            [SECURITY_ACTIONS.SHARE]: rowPermissions[AllPermissions.Share] && hasManage,
            [SECURITY_ACTIONS.ACTIVATE]: rowPermissions[AllPermissions.Activate],
            [SECURITY_ACTIONS.INACTIVATE]: rowPermissions[AllPermissions.Inactivate]
        };
    }, [activeOrganizationAccount, application, entitySecurity, feature, userProfile]);
}
